import { Component, Inject } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

import { ProgressBarService } from './core/services/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from './user/services/login.service';
import { MqttService, IMqttServiceOptions } from 'ngx-mqtt';

// setCulture('cs-CZ');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  host: {'class': 'app-root'}
})
export class AppComponent {
  title = 'Callipso';

  constructor(
    private router: Router,
    private progressBarService: ProgressBarService,
    private translate: TranslateService,
    private loginService: LoginService,
    private mqttService: MqttService,
    @Inject('BASE_URL') baseUrl: string
  ) {

    let language = localStorage.getItem('language');
    if (language) {
      translate.setDefaultLang(language);
    } else {
      translate.setDefaultLang('cs');
    }

    if (loginService.isLoggedIn) {
      let token = loginService.getMqttToken();
      let credentials = token.split(':');
      const url = new URL(baseUrl);

      const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
        //hostname: 'new-monitoring.vrvs.cz',
        hostname: url.hostname,
        port: 8084,
        path: '/mqtt',
        protocol: 'wss',
        clientId: 'Browser:' + String(Math.random()),
        username: credentials[0],
        password: credentials[1]
      };

      //Connect MQTT service
      this.mqttService.connect(MQTT_SERVICE_OPTIONS);
    }

    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.progressBarService.start();
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.progressBarService.end();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit(): void {
    /*L10n.load({
      'cs-CZ': {
        datepicker: {
          placeholder: "Vyberte datum",
          today: "Dnes"
        }
      }
    });*/
  }
}
